module.exports = __webpack_public_path__ + "media/images/icons/chevron-c37c6bdc212803760bc61a1b4dfd245e.svg";